import { AccessLevel } from '../../../types/AccessLevel';
import { CompanyAccessMessage } from '../../../types/CompanyAccessMessage';
import { UserRole } from '../../../types/UserRole';

export const identifyUserRole = (accessLevel: AccessLevel, companyAccesses?: CompanyAccessMessage[]) => {
    if (accessLevel === AccessLevel.ADMIN) {
        return UserRole.GROUP_ADMIN;
    }

    if (companyAccesses && companyAccesses.length) {
        if (accessLevel === AccessLevel.WRITE && companyAccesses[0].accessLevel === AccessLevel.ADMIN)
            return UserRole.COMPANY_ADMIN;

        if (accessLevel === AccessLevel.READ && companyAccesses[0].accessLevel === AccessLevel.WRITE)
            return UserRole.COMPANY_EMPLOYEE;

        if (accessLevel === AccessLevel.READ && companyAccesses[0].accessLevel === AccessLevel.READ)
            return UserRole.COMPANY_INSPECTOR;
    }

    return UserRole.CUSTOM;
};
